import React from 'react';
import PropTypes from 'prop-types';
import ScrollIntoView from 'react-scroll-into-view';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import { Link } from '@zola/zola-ui/src/components/Link';
import getProductPrices from './helpers';

const MSRPToolTip = `MSRP refers to the manufacturer’s suggested
retail price, which may not be the prevailing
market price or the regular retail price.`;

const KitProductOverview = (props) => {
  const { productData } = props;
  if (!productData) return null;
  const brandName = productData.brand.name;
  const brandKey = productData.brand.key;
  const productName = productData.name;
  const productDescription = productData.description;
  const productPrices = getProductPrices(productData);

  const showPriceCopy = (prices) => {
    if (prices.sale) return 'Sale';
    if (!prices.msrp) return '';
    if (prices.zolaPrice.match('-')) return 'Our Price';
    if (prices.priceNoRange) return 'Our Price';
    return '';
  };
  return (
    <div className="product-overview_container">
      <div className="product-details_container">
        <div className="product-details">
          <div className="brand-product-names-nonmobile">
            <Link
              variant="primary"
              noUnderline
              href={`/shop/brand/${brandKey}`}
              className="brand-name"
            >
              {brandName}
            </Link>
            <h1 className="product-name">{productName}</h1>
          </div>
          {productPrices.sale ? (
            <div className="msrp-price">
              Was <span className="was-price">{productPrices.msrp}</span>
            </div>
          ) : null}
          {productPrices.msrp && !productPrices.sale ? (
            <div className="msrp-price">
              MSRP
              <span data-tooltip={MSRPToolTip}>
                <i className="zolaicon-info" />
              </span>{' '}
              {productPrices.msrp}
            </div>
          ) : null}
          <div className="zola-price">
            {showPriceCopy(productPrices)} {productPrices.zolaPrice}
          </div>
          <span className="price-matching-text">
            <Link
              variant="primary"
              noUnderline
              href="/wedding-registry/benefits/price-match"
              className="base-text"
            >
              Price Matching Available
            </Link>
          </span>
          <div className="product-cta-mobile_container">
            <ScrollIntoView alignToTop selector="#also-need-products">
              <ButtonV2>
                <div>Choose Items Below</div>
              </ButtonV2>
            </ScrollIntoView>
            <div className="product-count-text">
              {productData.product_count} items in Collection
            </div>
          </div>
          <p className="product-description">{productDescription}</p>
        </div>
        <div className="product-cta-desktop_container">
          <ScrollIntoView alignToTop selector="#also-need-products">
            <ButtonV2>
              <div>Choose Items Below</div>
            </ButtonV2>
          </ScrollIntoView>
          <div className="product-count-text">{productData.product_count} items in Collection</div>
        </div>
      </div>
      <div id="also-need-products" />
    </div>
  );
};

KitProductOverview.propTypes = {
  productData: PropTypes.shape({
    brand: PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.number,
    }),
    name: PropTypes.string,
    description: PropTypes.string,
    product_count: PropTypes.number,
  }), // fetchProductByKey payload
};

export default KitProductOverview;
